
const api =
  process.env.NODE_ENV === "production"
    ? "https://claims-online-api.progress-ims.com/api"
    : "https://localhost:44328/api";

const baseStorageUrl =
  process.env.NODE_ENV === "production"
    ? "https://cm-files.progress-ims.com/Claims/"
    : "http://localhost:5001/";

function ShowLink(value) {
  var text = value;
  var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  var text1 = text.replace(exp, "<a href='$1'>$1</a>");
  var exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  return text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
}

function HtmlNewLine(value) {
  return value.replace(/(?:\r\n|\r|\n)/g, "<br />");
}

function Round2(num) {
  return Math.round(num * 100) / 100;
}

function DaysBetween(dt1, dt2) {
  var oneday = 1000 * 60 * 60 * 24;
  dt1 = new Date(dt1);
  dt2 = new Date(dt2);
  var diff = Math.round(dt2.getTime() - dt1.getTime()) / oneday;

  var res = diff.toFixed(0);
  return res;
}

function DateToString(dt, loc) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();
  if (loc == "AZ") return date + "." + month + "." + year;
  else return year + "-" + month + "-" + date;
}

function DateTimeToString(dt, loc) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");

  if (loc == "AZ")
    return (
      date +
      "." +
      month +
      "." +
      year +
      " " +
      hour +
      ":" +
      minutes +
      ":" +
      seconds
    );
  else
    return (
      year +
      "-" +
      month +
      "-" +
      date +
      " " +
      hour +
      ":" +
      minutes +
      ":" +
      seconds
    );
}

function DateTimeReverseToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");
  return (
    date + "." + month + "." + year + " " + hour + ":" + minutes + ":" + seconds
  );
}
function DateOnly(dt) {
  let x = new Date(dt).toDateString() + " 00:00";
  return new Date(x);
}

function AppointmentTime(dt) {
  const timelist = [
    "9:00",
    "9:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
  ];
  let selected = DateOnly(new Date(dt));
  let now = DateOnly(new Date());
  let diff = DaysBetween(now, selected);
  if (diff >= 0) {
    if (diff == 0) {
      let ch = new Date().getHours();
      if (ch > 17) return [];
      else {
        let arr = timelist.filter(
          (c) => parseInt(c.replace(":", "")) > ch * 100 + 30
        );
        return arr;
      }
    } else {
      return timelist;
    }
  }
}

export {
  ShowLink,
  HtmlNewLine,
  api,
  Round2,
  DaysBetween,
  DateToString,
  DateTimeToString,
  AppointmentTime,
  DateOnly,
  DateTimeReverseToString,
  baseStorageUrl
};
